import { PlaneCarIcon } from './PlaneCarIcon';

/**
 * author: Michael Irigoyen
 * id 604EF539-0143-4862-957A-AA04EFF9CD4E
 * name plane-car
 * version: 6.9.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/plane-car.svg
 * tags
 * - Transportation + Flying 
 * - Transportation + Road 
 */
export const AirplaneCarIcon = PlaneCarIcon;
export default AirplaneCarIcon